module.exports = __webpack_public_path__ + "static/img/phone.0bd31ab6.png";